module.exports = __webpack_public_path__ + "img/SES_220252003.51fdce5c.jpg";